'use client';
import { type RequirementIdentifier, type UserCredentialsCode } from '@capsicum/common';
import { atom } from 'jotai';

type DeniedCredentialAtom =
	| {
			credentialCodes: Array<UserCredentialsCode> | null | UserCredentialsCode;
			onCredentialGranted?: () => void;
			requirementIdentifier?: never;
	  }
	| {
			credentialCodes?: never;
			onCredentialGranted?: never;
			requirementIdentifier: RequirementIdentifier;
	  };

export const deniedCredentialAtom = atom<DeniedCredentialAtom>({ credentialCodes: null });
